import React, { useMemo } from 'react';
import classNames from 'classnames';
import ResolvePopup from 'components/ResolvePopup';
import utils from 'utils';

import './TruncatedText.styles.scss';

const MAX_CHARS = 26;

type TruncatedTextProps = {
  className?: string;
  popupClassName?: string;
  text: string;
  maxChars?: number;
  disableTooltip?: boolean;
};

const TruncatedText: React.FC<TruncatedTextProps> = (props) => {
  const {
    className,
    popupClassName,
    text = '',
    maxChars = MAX_CHARS,
    disableTooltip = false,
  } = props;

  const isTruncated = useMemo(
    () => text.length > maxChars,
    [maxChars, text.length],
  );

  const displayText = useMemo(
    () => (isTruncated ? utils.getShortenedString(text, maxChars) : text),
    [isTruncated, maxChars, text],
  );

  const content = (
    <span className={classNames('truncated-text', className)}>
      {displayText}
    </span>
  );

  if (isTruncated && !disableTooltip)
    return (
      <ResolvePopup
        onHover
        popupContent={text}
        className={classNames(popupClassName, 'truncated-text__popup')}
        preferUpwards
      >
        {content}
      </ResolvePopup>
    );

  return content;
};

export default TruncatedText;
